import { Section } from "components/layout";

import { ReleaseStageTabs } from "../../_shared";
import { PresentationConfigsByStage } from "../components";
import { TEXTS } from "../constants";
import styles from "./styles.scss";

export function TiVoAppFormPresentationTab() {
  return (
    <ReleaseStageTabs getTabTestId={(stage) => `${stage}-tab`}>
      {(selectedStage) => (
        <Section
          header={`${TEXTS.PRESENTATION.CONFIGS_HEADER} for ${selectedStage}`}
          className={styles.presentation}
        >
          <PresentationConfigsByStage selectedStage={selectedStage} />
        </Section>
      )}
    </ReleaseStageTabs>
  );
}
